
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1598326995472",
    "class": "icon",
    "viewBox": "0 0 1152 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "9426",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "562.5",
    "height": "500"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1146.496 435.392c-4.512-23.808-28.64-48-53.696-53.376l-18.72-4.064c-44-12.64-83.008-40.288-107.808-80.992a169.184 169.184 0 0 1-19.84-130.08l5.856-16.704c7.456-23.136-2.24-55.072-21.888-70.944 0 0-17.6-14.144-67.232-41.376-49.632-27.008-71.04-34.496-71.04-34.496-24.128-8.352-57.984-0.416-75.552 17.376l-13.088 13.28c-33.376 30.016-78.272 48.224-127.872 48.224s-94.976-18.432-128.352-48.64l-12.64-12.864c-17.376-17.792-51.424-25.728-75.552-17.344 0 0-21.664 7.52-71.264 34.496-49.632 27.424-66.976 41.568-66.976 41.568-19.616 15.648-29.312 47.36-21.888 70.72l5.408 16.928c10.592 42.656 4.96 88.928-19.84 129.888s-64.288 68.8-108.48 81.216l-18.048 3.84c-24.8 5.376-49.184 29.376-53.696 53.376 0 0-4.064 21.44-4.064 75.872s4.064 75.872 4.064 75.872c4.512 24 28.64 48 53.696 53.376l17.6 3.872c44.192 12.416 83.904 40.288 108.704 81.44a169.056 169.056 0 0 1 19.84 130.08l-5.184 16.512c-7.456 23.136 2.24 55.072 21.888 70.944 0 0 17.6 14.144 67.232 41.376s71.04 34.496 71.04 34.496c24.128 8.352 57.984 0.416 75.584-17.376l12.416-12.64c33.6-30.208 78.72-48.64 128.576-48.64s95.168 18.656 128.576 48.864l12.416 12.64c17.376 17.792 51.424 25.728 75.552 17.344 0 0 21.664-7.488 71.264-34.496 49.632-27.232 66.976-41.376 66.976-41.376 19.616-15.648 29.312-47.584 21.888-70.944l-5.408-17.152a168.736 168.736 0 0 1 19.84-129.44c24.8-40.928 64.512-69.024 108.704-81.44l17.6-3.872c24.8-5.344 49.184-29.344 53.696-53.376 0 0 4.064-21.44 4.064-75.872-0.224-54.656-4.288-76.064-4.288-76.064z m-570.88 293.824c-126.528 0-229.408-97.504-229.408-217.952 0-120.224 102.624-217.76 229.408-217.76 126.528 0 229.376 97.504 229.376 217.952-0.224 120.224-102.848 217.76-229.376 217.76z",
        "p-id": "9427"
      }
    }
  ]
})
    }
  